import { render, staticRenderFns } from "./zgznewsxq.vue?vue&type=template&id=7166142d&scoped=true"
import script from "./zgznewsxq.vue?vue&type=script&lang=js"
export * from "./zgznewsxq.vue?vue&type=script&lang=js"
import style0 from "./zgznewsxq.vue?vue&type=style&index=0&id=7166142d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166142d",
  null
  
)

export default component.exports